import { render, staticRenderFns } from "./HistoryViewDuration.vue?vue&type=template&id=9881aad4&"
import script from "./HistoryViewDuration.vue?vue&type=script&lang=js&"
export * from "./HistoryViewDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports